import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import QubiqRepublicVisual from "../QubiqRepublicVisual/QubiqRepublicVisual";

const QubiqRepublicButton = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [hover, setHover] = useState(false);
  const { t } = useTranslation();

  const isRankingPage = location.pathname.startsWith("/ranking");
  const isYellow = hover || isRankingPage;

  const handleClick = () => {
    navigate("/ranking", { state: { activeTab: "classements-map" } });
  };

  return (
    <Box className="qubiq-republic-button-and-flag">
      <button
        className={`qubiq-republic-button ${isRankingPage ? "is-active" : ""}`}
        type="button"
        onClick={handleClick}
        onMouseEnter={() => setHover(true)}
        onMouseLeave={() => setHover(false)}
      >
        <span className="qubiq-republic-label teko-button-text">{t("navigation.rankings")}</span>

        <span className="pirate-flag-span">
          <QubiqRepublicVisual isYellow={isYellow} />
        </span>
      </button>
    </Box>
  );
};

export default QubiqRepublicButton;
